export default {
  i18n: {
    breadcrumb: 'International Products',
    tips: 'Click on the button to change the current language.',
    btn: 'Switch Chinese',
    title1: 'Common usage',
    p1: 'If you reveal your secrets to the wind you should not blame the wind for  revealing them to the trees.',
    p2: 'Nothing can help us endure dark times better than our faith.',
    p3: "If you can do what you do best and be happy, you're further along in life  than most people.",
    title2: 'Component interpolation',
    info: 'The default language of Element is Chinese. If you wish to use another language, please refer to the {action}.',
    value: 'documentation'
  }
  ,
  layout: {
    header: {
      logo: 'KJ3231 Coal Production Management System'
    }
    ,
    notFound: {
      desc: 'Oops~ The page you visited does not exist',
      backHome: 'Back to Home',
      backPrev: 'Go Back'
    }
  }
  ,
  header: {
    tooltips: {
      fullscreenEnter: 'Fullscreen',
      fullscreenCancel: 'Exit fullscreen',
      bellDefault: 'Message Center',
      bellWithCount: '{count} unread messages'
    }
  },
  pages: {
    login: {
      title: 'KJ3231 Coal Production Management System',
      submit: 'Sign In',
      usernamePlaceholder: 'Please enter username',
      passwordPlaceholder: 'Please enter password',
      rules: {
        usernameRequired: 'Please enter username',
        passwordRequired: 'Please enter password'
      },
      success: 'Login successful'
    },
    about: {
      breadcrumb: 'About',
      title: 'KJ3231 Coal Production Management System',
      backendVersion: 'Backend version',
      webVersion: 'Web version',
      fetchError: 'Network error! Failed to get list!'
    },
    running: {
      cumulativeT: 'Cumulative (t)',
      flowTh: 'Flow (t/h)',
      beltSpeedMs: 'Belt speed (m/s)',
      empty: 'No data found',
      videoNotSupported: 'Device not monitored or misconfigured'
    },
    tabs: {
      breadcrumb: 'Message Center',
      unreadLabel: 'Unread ({count})',
      markRead: 'Mark as read',
      markAllRead: 'Mark all read',
      readLabel: 'Read ({count})',
      delete: 'Delete',
      deleteAll: 'Delete all',
      noneWarning: 'No data',
      fetchError: 'Network error! Failed to fetch messages!',
      listError: 'Network error! Failed to get list!'
    },
    deviceList: {
      breadcrumb: 'Device List',
      loading: 'Loading...',
      index: 'Index',
      region: 'Region',
      mineName: 'Mine',
      scaleName: 'Scale',
      viewInfo: 'View Info',
      viewStatus: 'View Status',
      addSuccess: 'Added successfully',
      addFail: 'Add failed',
      updateSuccess: 'Updated successfully',
      updateFail: 'Update failed',
      fetchError: 'Network error! Failed to get list!',
      addError: 'Network error! Add failed',
      updateError: 'Network error! Update failed',
      accountRequired: 'Please enter account',
      nameRequired: 'Please enter name',
      pwdSet: 'Please set password',
      pwdMin: 'Password length at least 5',
      pwdConfirmRequired: 'Please enter confirm password',
      pwdMismatch: 'Passwords do not match',
      roleTypeRequired: 'Please select role type',
      phoneRequired: 'Please enter phone',
      lengthRange: 'Length 3 to 15 characters'
    },
    globalSet: {
      breadcrumb: 'Feature Module Settings',
      homeColors: {
        title: 'Home Color Settings',
        menuBg: 'Menu background',
        homeBg: 'Home background',
        titleColor: 'Title',
        textColor: 'Text',
        button1: 'Button 1',
        button2: 'Button 2'
      },
      actions: {
        save: 'Save',
        restoreDefault: 'Restore default',
        confirm: 'Confirm',
        uploadQuery: 'Upload record query'
      },
      switch: {
        open: 'Open',
        close: 'Close',
        yes: 'Yes',
        no: 'No'
      },
      db14: { mainSwitch: 'DB14 file generation switch:' },
      zfw: { label: 'Generate ZFW file:' },
      dtjk: { label: 'Generate DTJKMY0002S file:' },
      snjson: {
        label: 'Generate SNJson file:',
        secondsSuffix: ':second(s) per generation'
      },
      report: {
        label: 'Generate Washing Product daily report:',
        everyDay: 'Every day',
        oClock: "o'clock"
      },
      display: {
        cnb: 'Show capacity ratio:',
        device: 'Show device status:'
      },
      motor: { label: 'Motor monitoring:' },
      messageCenter: { label: 'Enable message center:' },
      companyName: { label: 'Show company name:' },
      virtual: {
        totalSwitch: 'Enable total cumulative virtual scale:',
        scaleNameLabel: 'Scale name:',
        scaleNamePlaceholder: 'Scale name'
      },
      multithreading: { label: 'Enable multithreading:' },
      coalPlatform: {
        title: 'Coal Info Supervision Platform Settings',
        mineName: 'Mine name:',
        mineNamePh: 'Mine name',
        mineCode: 'Mine code:',
        mineCodePh: 'Mine code',
        uploadScale: 'Upload scale',
        selectPlaceholder: 'Please select',
        serverIP: 'Server IP:',
        serverIPPh: 'Server IP',
        port: 'Port:',
        portPh: 'Server port',
        account: 'Account:',
        accountPh: 'Account',
        password: 'Password:',
        passwordPh: 'Password',
        dataUpload: 'Coal supervision data upload:',
        receivePound: 'Receive sales data:'
      },
      cloud: {
        title: 'Cloud Upload Settings',
        serverIP: 'Cloud server IP:',
        serverIPPh: 'Cloud server IP',
        port: 'Port:',
        portPh: 'Cloud server port',
        clientId: 'Client ID:',
        clientIdPh: 'Cloud client ID',
        account: 'Account:',
        accountPh: 'Cloud account',
        password: 'Password:',
        passwordPh: 'Cloud password',
        uploadSwitch: 'Enable data upload:'
      }
    },
    alarmControl: {
      breadcrumb: 'Alarm Control',
      title: 'Alarm Control',
      statusActive: 'Alarm Active',
      statusMuted: 'Muted / Normal',
      turnOn: 'Turn On Alarm',
      turnOff: 'Mute (Turn Off)'
    },
    basicInfo: {
      startTime: 'Start time',
      lastStopTime: 'Last stop time',
      todayRunDuration: 'Today run duration',
      cumulativeT: 'Cumulative (t)',
      flowTh: 'Flow (t/h)',
      beltSpeedMs: 'Belt speed (m/s)',
      dayProduction: 'Daily production (t)',
      monthProduction: 'Monthly production (t)',
      yearProduction: 'Yearly production (t)',
      viewMore: 'View more info',
      empty: 'No data found',
      videoNotSupported: 'Device not monitored or misconfigured',
      connectSuccess: 'Connected',
      connectFail: 'Disconnected'
    }
    ,
    dynamic: {
      cumulativeT: 'Cumulative (t)',
      flowTh: 'Flow (t/h)',
      beltSpeedMs: 'Belt speed (m/s)',
      empty: 'No data found',
      videoNotSupported: 'Device not monitored or misconfigured'
    }
    ,
    moreDeviceInfo: {
      back: 'Back',
      clockSync: 'Clock sync',
      clientTime: 'Local time',
      serverTime: 'Server time',
      timeDiffSec: 'Time diff (sec)',
      syncedTime: 'Calibrated time',
      offsetSec: 'Manual offset (sec)',
      useServerTime: 'Use server time',
      clockSyncSaved: 'Clock calibration saved',
      serverTimeUnavailable: 'Server time unavailable',
      cumulativeT: 'Cumulative (t)',
      flowTh: 'Flow (t/h)',
      beltSpeedMs: 'Belt speed (m/s)',
      startTime: 'Start time',
      lastStopTime: 'Last stop time',
      todayRunDuration: 'Today run duration',
      dayProduction: 'Daily production (t)',
      monthProduction: 'Monthly production (t)',
      yearProduction: 'Yearly production (t)',
      hourCNB: 'Hourly CNB (%)',
      monthCNB: 'Monthly CNB (%)',
      dayCNB: 'Daily CNB (%)',
      yearCNB: 'Yearly CNB (%)',
      empty: 'No data found',
      hourBar: 'Hourly production bar',
      dayBar: 'Daily production bar',
      monthBar: 'Monthly production bar',
      yearBar: 'Yearly production bar',
      realtimeFlow: 'Real-time flow curve',
      axisHour: 'Time (hour)',
      axisDay: 'Time (day)',
      axisMonth: 'Time (month)',
      axisYear: 'Time (year)',
      axisTime: 'Time',
      axisProdT: 'Production (t)',
      axisFlow: 'Flow',
      diagramConnOk: 'Connected',
      diagramConnBad: 'Disconnected',
      diagramCameraOk: 'Camera Normal',
      diagramCameraBad: 'Camera Error',
      videoNotSupported: 'Device not monitored or misconfigured'
    }
    ,
    coalTaxCalc: {
      breadcrumb: 'Conversion & tax estimate',
      title: 'Conversion & tax estimate',
      loadDemo: 'Load demo',
      calculate: 'Calculate',
      fillDemo: 'Fill demo',
      calcDone: 'Calculated',
      resultEmpty: 'Enter parameters and click “Calculate” to generate results.',
      showDetails: 'Details',
      hideDetails: 'Hide details',
      summaryTableTitle: 'Conversion & settlement summary',
      detailTableTitle: 'Tax/fee details',
      groupConversion: 'Conversion',
      groupSettlement: 'Settlement',
      colValue: 'Value',
      colUnit: 'Unit',
      colFormula: 'Formula',
      yuan: 'CNY',
      tceUnit: 'tce',
      formulaInput: 'Input',
      formulaRawCoalT: 'Gross × coefficient',
      formulaStdCoalT: 'Raw × net calorific ÷ 7000',
      formulaSalesExVat: 'Raw × unit price (excl. VAT)',
      formulaVat: 'Sales excl. VAT × VAT rate',
      formulaSalesIncVat: 'Sales excl. VAT + VAT',
      formulaOtherTaxFee: 'All taxes/fees excluding VAT',
      formulaTotalTaxFee: 'Other taxes/fees + VAT',
      formulaNetSettle: 'Sales excl. VAT - other taxes/fees (excl. VAT)',
      resultMeaningTitle: 'Result notes',
      meaningRawCoalT: 'Raw coal: gross × conversion coefficient.',
      meaningStdCoalT: 'Standard coal: raw × net calorific ÷ 7000.',
      meaningSalesExVat: 'Sales excl. VAT: raw × unit price (excl. VAT).',
      meaningVat: 'VAT output: sales excl. VAT × VAT rate.',
      meaningTotalTaxFee: 'Total taxes/fees (incl. VAT): other taxes/fees + VAT output.',
      meaningNetSettle: 'Net settlement (excl. VAT): sales excl. VAT - other taxes/fees (excluding VAT).',
      grossCoalT: 'Gross coal (t)',
      convertCoeff: 'Gross→raw conversion coeff',
      qnetKcalKg: 'Net calorific (kcal/kg)',
      unitPriceExVat: 'Unit price excl. VAT (CNY/t)',
      vatRate: 'VAT rate (%)',
      resourceTaxRate: 'Resource tax rate (%)',
      citySurtaxRate: 'City surtax rate (%)',
      eduSurtaxRate: 'Education surtax rate (%)',
      localEduSurtaxRate: 'Local edu surtax rate (%)',
      safetyFundPerTon: 'Safety fund (CNY/t)',
      envFundPerTon: 'Eco fund (CNY/t)',
      otherFundRate: 'Other fund rate (%)',
      resultTitle: 'Result',
      rawCoalT: 'Raw coal after conversion (t)',
      stdCoalT: 'Standard coal (tce)',
      salesExVat: 'Sales excl. VAT (CNY)',
      vatAmount: 'VAT output (CNY)',
      salesIncVat: 'Sales incl. VAT (CNY)',
      totalOtherTaxFee: 'Other taxes/fees excl. VAT (CNY)',
      totalTaxFee: 'Total taxes/fees incl. VAT (CNY)',
      netExVatAfterTaxFee: 'Net settlement excl. VAT (CNY)',
      colName: 'Item',
      colBase: 'Base',
      colRate: 'Rate',
      colAmount: 'Amount (CNY)',
      colNote: 'Note',
      resourceTax: 'Resource tax',
      vat: 'VAT',
      citySurtax: 'City surtax',
      eduSurtax: 'Education surtax',
      localEduSurtax: 'Local edu surtax',
      safetyFund: 'Safety fund',
      envFund: 'Eco fund',
      otherFund: 'Other fund',
      baseSalesExVat: 'Sales excl. VAT',
      baseVat: 'VAT',
      baseRawCoal: 'Raw coal',
      yuanPerTon: ' CNY/t',
      noteRateOnSales: 'Based on sales excl. VAT',
      noteVatOutput: 'VAT output calculation',
      noteSurtaxOnVat: 'Based on VAT',
      notePerTonOnRaw: 'Based on raw coal quantity',
      noteConfigurableExample: 'Configurable',
      totalRow: 'Total (incl. VAT)',
      totalRowNote: 'Total taxes/fees including VAT',
      subtotalRow: 'Subtotal (excl. VAT)',
      subtotalRowNote: 'Taxes/fees excluding VAT',
      logicHint1: 'Conversion: raw = gross × coeff; standard coal = raw × Qnet ÷ 7000.',
      logicHint2: 'Tax/fee calculation uses common formulas; adjust parameters to match local policy.'
    }
    ,
    washingReport: {
      breadcrumb: 'Washing Product Daily Report',
      export: 'Export',
      selectDate: 'Select date',
      search: 'Search',
      title: 'Jincheng Company Washing Product Quantity & Quality Daily Report',
      index: 'Index',
      mineName: 'Mine',
      indicatorName: 'Indicator',
      selectedCoal: 'Selected raw coal',
      rawCoal: 'Washed raw coal',
      cleanCoal: 'Clean coal (fine)',
      lumpCoal: 'Clean coal (lump)',
      mediumCoal: 'Medium coal',
      slurry: 'Slurry',
      sieveCoal: 'Sieved mixed coal',
      day: 'Day',
      month: 'Month',
      year: 'Year',
      companyTotal: 'Company total',
      prodT: 'Production (t)',
      dateRequired: 'Date cannot be empty!',
      fetchError: 'Network error! Failed to get list!'
    }
    ,
    recordSearch: {
      breadcrumb: 'Record Search',
      rangeSeparator: 'to',
      startDate: 'Start date',
      endDate: 'End date',
      logType: 'Record type',
      all: 'All',
      login: 'Login',
      visit: 'Visit',
      operate: 'Operate',
      exception: 'Exception',
      search: 'Search',
      index: 'Index',
      operateTime: 'Operate time',
      operator: 'Operator',
      recordType: 'Record type',
      module: 'Module',
      source: 'Source',
      content: 'Content',
      detail: 'Detail',
      dateRequired: 'Date cannot be empty!',
      fetchError: 'Network error! Failed to get list!',
      shortcuts: {
        lastWeek: 'Last week',
        lastMonth: 'Last month',
        lastThreeMonths: 'Last three months'
      }
    }
    ,
    combinedCurve: {
      breadcrumb: 'Flow & Speed Curve',
      selectScale: 'Please select',
      datePh: 'Select date',
      startTimePh: 'Start time',
      endTimePh: 'End time',
      search: 'Search',
      flowCurveTitle: 'Flow Curve',
      speedCurveTitle: 'Speed Curve',
      warn: {
        scaleRequired: 'Please select scale',
        dateRequired: 'Please select date',
        startRequired: 'Please select start time',
        endRequired: 'Please select end time',
        timeRangeInvalid: 'Start time cannot be greater than end time'
      },
      fetchFlowError: 'Network error! Failed to get flow curve!',
      fetchSpeedError: 'Network error! Failed to get speed curve!',
      fetchDeviceError: 'Network error! Failed to get device list!',
      tooltip: {
        time: 'Time',
        flow: 'Flow',
        speed: 'Speed'
      }
    }
    ,
    dischargeCurve: {
      breadcrumb: 'Flow Curve',
      selectScale: 'Please select',
      datePh: 'Select date',
      startTimePh: 'Start time',
      endTimePh: 'End time',
      search: 'Search',
      warn: {
        scaleRequired: 'Please select scale',
        dateRequired: 'Please select date',
        startRequired: 'Please select start time',
        endRequired: 'Please select end time',
        timeRangeInvalid: 'Start time cannot be greater than end time'
      },
      fetchError: 'Network error! Failed to get list!',
      tooltip: {
        time: 'Time',
        flow: 'Flow'
      }
    }
    ,
    startStopRecord: {
      breadcrumb: 'Start/Stop Record',
      rangeSeparator: 'to',
      startDate: 'Start date',
      endDate: 'End date',
      scale: 'Scale',
      search: 'Search',
      loading: 'Loading...',
      index: 'Index',
      balanceId: 'Scale ID',
      balanceName: 'Scale name',
      startTime: 'Start time',
      stopTime: 'Stop time',
      startAccumulation: 'Start accumulation',
      stopAccumulation: 'Stop accumulation',
      runningTime: 'Running time',
      oneTimeYield: 'Yield of one run',
      all: 'All',
      dateRequired: 'Date cannot be empty!',
      fetchError: 'Network error! Failed to get list!'
    }
    ,
    offlineRecord: {
      breadcrumb: 'Offline Record',
      rangeSeparator: 'to',
      startDate: 'Start date',
      endDate: 'End date',
      scale: 'Scale',
      search: 'Search',
      loading: 'Loading...',
      index: 'Index',
      balanceId: 'Scale ID',
      balanceName: 'Scale name',
      connectionFailureTime: 'Connection failure time',
      connectionRecoveryTime: 'Connection recovery time',
      offlineDuration: 'Offline duration',
      all: 'All',
      dateRequired: 'Date cannot be empty!',
      fetchError: 'Network error! Failed to get list!'
    }
    ,
    hisData: {
      breadcrumb: 'Historical Data',
      rangeSeparator: 'to',
      startDate: 'Start date',
      endDate: 'End date',
      scale: 'Scale',
      search: 'Search',
      loading: 'Loading...',
      index: 'Index',
      operateTime: 'Operate time',
      scaleId: 'Scale ID',
      scaleName: 'Scale name',
      shift: 'Shift',
      speed: 'Speed (m/s)',
      flow: 'Flow (t/h)',
      weight: 'Weight (t)',
      totalWeightCol: 'Total weight (t)',
      loadingMore: 'Loading more...',
      noMore: 'No more data',
      dateRequired: 'Date cannot be empty!',
      yes: 'Yes',
      all: 'All',
      fetchError: 'Network error! Failed to get list!'
    }
    ,
    eventRecord: {
      breadcrumb: 'Monitoring Record',
      rangeSeparator: 'to',
      startDate: 'Start date',
      endDate: 'End date',
      eventType: 'Event type',
      search: 'Search',
      loading: 'Loading...',
      index: 'Index',
      alarmTime: 'Alarm time',
      eventTypeCol: 'Alarm event',
      alarmInfo: 'Alarm info',
      operation: 'Operation',
      view: 'View',
      viewTitle: 'View Details',
      close: 'Close',
      all: 'All',
      dateRequired: 'Date cannot be empty!',
      fetchError: 'Network error! Failed to get list!',
      shortcuts: {
        lastWeek: 'Last week',
        lastMonth: 'Last month',
        lastThreeMonths: 'Last three months'
      }
    }
    ,
    personInfo: {
      tabsBase: 'Basic Settings',
      tabsSecurity: 'Security Settings',
      baseTitle: 'Basic Settings',
      securityTitle: 'Security Settings',
      loginId: 'Account',
      deptName: 'Department',
      realName: 'Name',
      remark: 'Profile',
      avatar: 'Avatar',
      updateProfile: 'Update Profile',
      oldPassword: 'Old Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      updatePwd: 'Update Password',
      rules: {
        nameRequired: 'Please enter name',
        oldRequired: 'Please enter old password',
        oldError: 'Old password is incorrect!',
        newRequired: 'Please enter new password',
        confirmRequired: 'Please enter confirm password',
        mismatch: 'New password and confirm do not match!'
      },
      confirmUpdateProfile: 'Confirm to update profile?',
      confirmUpdatePwd: 'Confirm to update password?',
      confirmTitle: 'Tip',
      addFail: 'Add failed',
      updateFail: 'Update failed!',
      networkAddError: 'Network error! Add failed'
    }
    ,
    tags: {
      options: 'Tag Options',
      closeOther: 'Close Others',
      closeAll: 'Close All'
    }
    ,
    handover: {
      print: 'Print',
      printTitle: 'Print Document'
    }
    ,
    coalUploadRecord: {
      breadcrumb: 'Coal Info Supervision Upload Records',
      rangeSeparator: 'to',
      startDate: 'Start date',
      endDate: 'End date',
      recordType: 'Record type',
      all: 'All',
      fail: 'Fail',
      success: 'Success',
      search: 'Search',
      index: 'Index',
      uploadTime: 'Upload time',
      apiName: 'API name',
      result: 'Upload result',
      code: 'Code',
      msg: 'Message',
      content: 'Payload',
      detail: 'Detail',
      dateRequired: 'Date cannot be empty!',
      fetchError: 'Network error! Failed to get list!'
    }
    ,
    hourData: {
      breadcrumb: 'Hourly Production Details',
      print: 'Print',
      export: 'Export',
      totalWeight: 'Total production (t):',
      rangeSeparator: 'to',
      startDate: 'Start date',
      endDate: 'End date',
      scale: 'Scale',
      search: 'Search',
      index: 'Index',
      date: 'Date',
      scaleName: 'Scale name',
      shift: 'Shift',
      hourWeight: 'Hourly production (t)',
      cnb: 'Capacity ratio (%)',
      invalidTime: 'Invalid time',
      shortcuts: {
        lastWeek: 'Last week',
        lastMonth: 'Last month',
        lastThreeMonths: 'Last three months'
      },
      dateRequired: 'Date cannot be empty!',
      yes: 'Yes',
      fetchError: 'Network error! Failed to get list!',
      printTitle: 'Hourly Production Details',
      axisHour: 'Time (hour)'
    }
    ,
    dayData: {
      breadcrumb: 'Daily Production Details',
      print: 'Print',
      export: 'Export',
      totalWeight: 'Total production (t):',
      rangeSeparator: 'to',
      startDate: 'Start date',
      endDate: 'End date',
      scale: 'Scale',
      search: 'Search',
      index: 'Index',
      date: 'Date',
      scaleId: 'Scale ID',
      scaleName: 'Scale name',
      dayWeight: 'Daily production (t)',
      dayCnb: 'Daily CNB (%)',
      shortcuts: {
        lastWeek: 'Last week',
        lastMonth: 'Last month',
        lastThreeMonths: 'Last three months'
      },
      dateRequired: 'Date cannot be empty!',
      yes: 'Yes',
      fetchError: 'Network error! Failed to get list!',
      printTitle: 'Daily Production Details'
    }
    ,
    monthData: {
      breadcrumb: 'Monthly Production Details',
      print: 'Print',
      export: 'Export',
      totalWeight: 'Total production (t):',
      rangeSeparator: 'to',
      startMonth: 'Start month',
      endMonth: 'End month',
      scale: 'Scale',
      search: 'Search',
      index: 'Index',
      date: 'Date',
      scaleId: 'Scale ID',
      scaleName: 'Scale name',
      monthWeight: 'Monthly production (t)',
      monthCnb: 'Monthly CNB (%)',
      shortcuts: {
        thisMonth: 'This month',
        ytd: 'Year to date',
        lastSixMonths: 'Last six months'
      },
      yes: 'Yes',
      fetchError: 'Network error! Failed to get list!',
      printTitle: 'Monthly Production Details'
    }
    ,
    yearData: {
      breadcrumb: 'Annual Production Details',
      print: 'Print',
      export: 'Export',
      totalWeight: 'Total production (t):',
      startYear: 'Start year',
      endYear: 'End year',
      scale: 'Scale',
      search: 'Search',
      index: 'Index',
      year: 'Year',
      scaleId: 'Scale ID',
      scaleName: 'Scale name',
      yearWeight: 'Annual production (t)',
      yearCnb: 'Annual CNB (%)',
      yes: 'Yes',
      fetchError: 'Network error! Failed to get list!',
      printTitle: 'Annual Production Details'
    }
    ,
    monthCCData: {
      breadcrumb: 'Monthly Overproduction',
      print: 'Print',
      export: 'Export',
      annualCapacity: 'Annual capacity (kt)',
      monthlyCapacity: 'Monthly capacity (t)',
      dayCapacity: 'Daily capacity (t)',
      monthlyOutput: 'Monthly output (t)',
      monthlyCapacityRatio: 'Monthly CNB (%)',
      overproductionNum: 'Overproduction count',
      monthPh: 'Select month',
      scale: 'Scale',
      search: 'Search',
      index: 'Index',
      scaleName: 'Scale name',
      dayWeight: 'Daily output (t)',
      dayCnb: 'CNB (%)',
      overproductionStatus: 'Overproduction level',
      normal: 'Normal',
      overproduction: 'Overproduction',
      severeOverproduction: 'Severe overproduction',
      exceed: 'Exceed',
      overproductionDateDay: 'Date (day)',
      yes: 'Yes',
      all: 'All',
      fetchError: 'Network error! Failed to get list!',
      printTitle: 'Monthly Overproduction Details'
    }
    ,
    yearCCData: {
      breadcrumb: 'Annual Overproduction',
      print: 'Print',
      export: 'Export',
      annualCapacity: 'Annual capacity (kt)',
      monthlyCapacity: 'Monthly capacity (t)',
      annualOutput: 'Annual output (t)',
      annualCapacityRatio: 'Annual CNB (%)',
      overproductionNum: 'Overproduction count',
      yearPh: 'Select year',
      scale: 'Scale',
      search: 'Search',
      index: 'Index',
      scaleName: 'Scale name',
      overWeight: 'Overproduction output (t)',
      monthCnb: 'Monthly CNB (%)',
      overproductionStatus: 'Overproduction level',
      normal: 'Normal',
      overproduction: 'Overproduction',
      severeOverproduction: 'Severe overproduction',
      exceed: 'Exceed',
      overproductionDateMonth: 'Date (month)',
      yes: 'Yes',
      all: 'All',
      fetchError: 'Network error! Failed to get list!',
      printTitle: 'Annual Overproduction Details'
    }
    ,
    mtStd: {
      search: 'Search',
      print: 'Print',
      export: 'Export',
      all: 'All',
      index: 'Index',
      mine: 'Coal Mine',
      unit: 'Unit',
      unitT: 't',
      cnb: 'Ratio',
      annualCapacity: 'Annual Capacity (kt)',
      monthCapacity: 'Monthly Capacity (Plan) (t)',
      dayCapacity: 'Daily Capacity (Plan) (t)',
      hourCapacity: 'Hourly Capacity (Plan) (t)',
      yearOutput: 'Annual Output',
      monthOutput: 'Monthly Output',
      dayOutput: 'Daily Output',
      output: ' Output',
      overOutput: 'Over Output',
      timeCol: 'Time',
      monthUnit: 'M',
      dayUnit: 'D',
      hourUnit: ':00',
      overMonths: 'Over Months',
      overDays: 'Over Days',
      nth: '#',
      nthAfter: ' ',
      status: 'Status',
      cumCount: 'Total Count',
      cumTime: 'Duration',
      timeSpan: 'Start~End',
      remark: 'Remark',
      typePh: 'Event Type',
      yearPh: 'Select Year',
      monthPh: 'Select Month',
      yearStartPh: 'Start Year',
      yearEndPh: 'End Year',
      monthStartPh: 'Start Month',
      monthEndPh: 'End Month',
      dateStartPh: 'Start Date',
      dateEndPh: 'End Date',
      yearSuffix: '',
      hours: 'h',
      minutes: 'min',
      fetchError: 'Network error! Failed to get data!',
      rangeError: 'Start time cannot be later than end time'
    }
    ,
    mtOverYearShow: {
      breadcrumb: 'Annual Overproduction Display',
      printTitle: 'Annual Overproduction Display'
    }
    ,
    mtOverMonthShow: {
      breadcrumb: 'Monthly Overproduction Display',
      printTitle: 'Monthly Overproduction Display'
    }
    ,
    mtOutputYearQuery: {
      breadcrumb: 'Annual Output Query & Display',
      printTitle: 'Annual Output Query & Display'
    }
    ,
    mtOutputMonthQuery: {
      breadcrumb: 'Monthly Output Query & Display',
      printTitle: 'Monthly Output Query & Display'
    }
    ,
    mtOutputDayQuery: {
      breadcrumb: 'Daily Output Query & Display',
      printTitle: 'Daily Output Query & Display'
    }
    ,
    mtAbnormalDisplay: {
      breadcrumb: 'System Abnormality Display',
      printTitle: 'System Abnormality Display'
    }
    ,
    scaleGroup: {
      breadcrumb: 'Feeder Group Management',
      add: 'Add',
      delete: 'Delete',
      viewDict: 'View Group Dictionary',
      selectPh: 'Please select',
      all: 'All',
      percent: 'Percent',
      ratio: 'Ratio',
      search: 'Search',
      loading: 'Loading...',
      index: 'Index',
      groupName: 'Group name',
      totalFlow: 'Total flow',
      percentType: 'Percent type',
      enabled: 'Enabled',
      modifyTime: 'Operate time',
      operation: 'Operation',
      edit: 'Edit',
      feederName: 'Feeder name',
      materialName: 'Material name',
      ratioCol: 'Ratio',
      setFlow: 'Set flow',
      cancel: 'Cancel',
      confirm: 'Confirm',
      viewDictTitle: 'View Scale Dictionary',
      searchPh: 'Enter group/device/material name',
      deviceName: 'Device name',
      close: 'Close',
      addTitle: 'Add Group Info',
      editTitle: 'Edit Group Info',
      tip: 'Tip',
      confirmDelete: 'Are you sure to delete?',
      confirmDeleteChild: 'Are you sure to delete? (Child items will also be deleted)',
      deleteError: 'Network error! Delete failed',
      fetchError: 'Network error! Failed to get list!',
      warn: {
        selectToDelete: 'Please select rows to delete'
      }
    }
    ,
    balanceEmpower: {
      breadcrumb: 'Device Permission',
      add: 'Add',
      delete: 'Delete',
      searchPh: 'Name or scale',
      search: 'Search',
      loading: 'Loading...',
      index: 'Index',
      user: 'User',
      device: 'Device',
      detail: 'Detail',
      modifyTime: 'Operate time',
      operation: 'Operation',
      edit: 'Edit',
      selectPh: 'Please select',
      deviceDisplay: 'Device display',
      cancel: 'Cancel',
      confirm: 'Confirm',
      addTitle: 'Add Device Permission',
      editTitle: 'Edit Device Permission',
      tip: 'Tip',
      confirmDelete: 'Are you sure to delete?',
      deleteError: 'Network error! Delete failed',
      fetchError: 'Network error! Failed to get list!',
      addError: 'Network error! Add failed',
      updateError: 'Network error! Update failed',
      valid: {
        userRequired: 'Please select user'
      },
      warn: {
        selectToDelete: 'Please select rows to delete'
      }
    }
    ,
    monitorEqu: {
      breadcrumb: 'Monitoring Devices',
      add: 'Add',
      deployAll: 'Deploy All',
      undeployAll: 'Undeploy All',
      namePh: 'Name',
      search: 'Search',
      loading: 'Loading...',
      index: 'Index',
      scaleName: 'Scale name',
      deviceName: 'Device name',
      deviceIP: 'Device IP',
      devicePort: 'Device port',
      status: 'Status',
      enabled: 'Enabled',
      userName: 'Username',
      modifyTime: 'Operate time',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      monitorTarget: 'Monitored device',
      selectPh: 'Please select',
      password: 'Password',
      urlSuffix: 'URL suffix',
      use: 'Use',
      cancel: 'Cancel',
      confirm: 'Confirm',
      addTitle: 'Add Monitoring Device',
      editTitle: 'Edit Monitoring Device',
      tip: 'Tip',
      confirmDelete: 'Are you sure to delete?',
      confirmDeploy: 'Are you sure to deploy?',
      confirmUndeploy: 'Are you sure to undeploy?',
      addSuccess: 'Added successfully',
      addError: 'Network error! Add failed',
      updateSuccess: 'Updated successfully',
      updateFail: 'Update failed',
      updateError: 'Network error! Update failed',
      deleteFail: 'Delete failed',
      deleteError: 'Network error! Delete failed',
      deleteSuccess: 'Deleted {name}',
      deleteBatchSuccess: 'Deleted {names}',
      fetchError: 'Network error! Failed to get list!',
      valid: {
        deviceNameRequired: 'Please enter device name',
        deviceNameLength: 'Length 2 to 15 characters',
        deviceIpRequired: 'Please enter device IP',
        devicePortRequired: 'Please enter device port',
        userNameRequired: 'Please enter username',
        passwordRequired: 'Please enter password',
        balanceRequired: 'Please select device'
      },
      warn: {
        selectToDelete: 'Please select rows to delete'
      }
    }
    ,
    productPlan: {
      breadcrumb: 'Production Plan Management',
      add: 'Add',
      delete: 'Delete',
      searchPh: 'Name or scale',
      search: 'Search',
      loading: 'Loading...',
      index: 'Index',
      name: 'Name',
      yearProd: 'Annual production',
      monthProd: 'Monthly production',
      dayProd: 'Daily production',
      hourProd: 'Hourly production',
      enabled: 'Enabled',
      modifyTime: 'Operate time',
      operation: 'Operation',
      edit: 'Edit',
      yearPlan: 'Annual plan (kt)',
      monthPlan: 'Monthly plan (t)',
      dayPlan: 'Daily plan (t)',
      hourPlan: 'Hourly plan (t)',
      cancel: 'Cancel',
      confirm: 'Confirm',
      addTitle: 'Add Production Plan',
      editTitle: 'Edit Production Plan',
      tip: 'Tip',
      confirmDelete: 'Are you sure to delete?',
      deleteSuccess: 'Deleted [{names}] production plans',
      deleteFail: 'Delete failed',
      deleteError: 'Network error! Delete failed',
      fetchError: 'Network error! Failed to get list!',
      addSuccess: 'Added successfully',
      addError: 'Network error! Add failed',
      updateSuccess: 'Updated successfully',
      updateFail: 'Update failed',
      updateError: 'Network error! Update failed',
      valid: {
        nameRequired: 'Please enter name'
      },
      enabledTagOn: 'Enabled',
      enabledTagOff: 'Disabled',
      warn: {
        selectToDelete: 'Please select rows to delete'
      }
    }
    ,
    dataMain: {
      breadcrumb: 'Data Dictionary',
      filterPh: 'Enter keywords to filter',
      add: 'Add',
      delete: 'Delete',
      edit: 'Edit',
      dictType: 'Dictionary Category',
      searchPh: 'Enter item value or name',
      searchNameCodePh: 'Enter name or code',
      search: 'Search',
      index: 'Index',
      itemName: 'Item name',
      itemValue: 'Item value',
      order: 'Order',
      enabled: 'Enabled',
      remark: 'Remark',
      close: 'Close',
      cancel: 'Cancel',
      confirm: 'Confirm',
      parent: 'Parent',
      selectPh: 'Please select',
      name: 'Name',
      code: 'Code',
      editItemTitle: 'Edit Dictionary Item',
      addItemTitle: 'Add Dictionary Item',
      addTypeTitle: 'Add Category',
      editTypeTitle: 'Edit Category',
      tip: 'Tip',
      confirmDelete: 'Are you sure to delete?',
      deleteSuccess: 'Deleted {names}',
      deleteFail: 'Delete failed',
      deleteError: 'Network error! Delete failed',
      fetchError: 'Network error! Failed to get list!',
      addSuccess: 'Added successfully',
      addFail: 'Add failed',
      addError: 'Network error! Add failed',
      updateSuccess: 'Updated successfully',
      updateFail: 'Update failed',
      updateError: 'Network error! Update failed',
      valid: {
        nameRequired: 'Please enter item name',
        valueRequired: 'Please enter item value'
      },
      warn: {
        selectLeftCategory: 'Please select left category',
        selectLeafOnly: 'Selecting a directory is not allowed',
        selectToDelete: 'Please select rows to delete',
        selectOneToEdit: 'Please select one item to edit',
        onlyOneToEdit: 'Only one item allowed to edit',
        hasChildren: 'There are child items under the category, please delete them first'
      }
    }
    ,
    equimentVersion: {
      breadcrumb: 'Protocol Version Info',
      namePh: 'Name',
      search: 'Search',
      loading: 'Loading...',
      index: 'Index',
      name: 'Name',
      version: 'Version',
      organization: 'Company',
      modifyTime: 'Operate time',
      describe: 'Description'
    }
    ,
    clearData: {
      breadcrumb: 'Data Clearing',
      alert: 'Note: Data clearing cannot be recovered, proceed with caution!',
      scale: 'Scale',
      selectPh: 'Please select',
      type: 'Type',
      radio: {
        pcOnly: 'Clear PC data only',
        meterOnly: 'Clear meter data only',
        both: 'Clear both PC and meter data'
      },
      submit: 'Clear Data',
      tip: 'Tip',
      warn: {
        selectScale: 'Please select a scale'
      },
      confirmClear: 'Are you sure to clear data?',
      opError: 'Network error, operation failed!',
      fetchError: 'Network error! Failed to get list!'
    }
    ,
    role: {
      breadcrumb: 'Role Management',
      add: 'Add',
      delete: 'Delete',
      codePh: 'Code',
      namePh: 'Name',
      search: 'Search',
      loading: 'Loading...',
      index: 'Index',
      name: 'Role name',
      description: 'Role description',
      enabled: 'Enabled',
      operateTime: 'Operate time',
      actions: {
        edit: 'Edit'
      },
      fields: {
        name: 'Name',
        enabled: 'Enabled',
        description: 'Role description'
      },
      dialog: {
        cancel: 'Cancel',
        confirm: 'Confirm',
        editTitleUpdate: 'Edit Role',
        editTitleAdd: 'Add Role'
      },
      rules: {
        nameRequired: 'Please enter name',
        lengthRange: 'Length 2 to 15 characters'
      },
      notify: {
        addSuccess: 'Added successfully',
        addFail: 'Add failed',
        networkAddError: 'Network error! Add failed',
        updateSuccess: 'Updated successfully',
        updateFail: 'Update failed',
        networkUpdateError: 'Network error! Update failed',
        networkListError: 'Network error! Failed to get list!',
        deleteSelectedWarning: 'Please select rows to delete',
        deleteConfirm: 'Are you sure to delete?',
        deleteConfirmTitle: 'Tip',
        deleteSuccess: 'Deleted {names}',
        deleteFail: 'Delete failed',
        networkDeleteError: 'Network error! Delete failed'
      },
      companyRoot: 'Company root'
    }
    ,
    rolePermission: {
      breadcrumb: 'Role Permission',
      rolesTitle: 'Roles',
      permsTitle: 'Permissions',
      refresh: 'Refresh',
      save: 'Save',
      loading: 'Loading...',
      name: 'Name',
      fetchError: 'Network error! Failed to get list!',
      warn: {
        selectRole: 'Please select a role!',
        selectMenu: 'Please select a menu!'
      }
    }
    ,
    frequency: {
      breadcrumb: 'Plan Management',
      add: 'Add',
      delete: 'Delete',
      search: 'Search',
      namePh: 'Name',
      loading: 'Loading...',
      index: 'Index',
      planName: 'Plan name',
      shift1Name: 'Shift 1 name',
      shift1Start: 'Shift 1 start time',
      shift1End: 'Shift 1 end time',
      modifyTime: 'Operate time',
      operation: 'Operation',
      edit: 'Edit',
      shiftCount: 'Shift count',
      customSettlementOn: 'Custom settlement date',
      customSettlementOff: 'Default settlement date',
      eachMonth: 'Per month',
      shiftName: 'Shift name',
      startTime: 'Start time',
      endTime: 'End time',
      startTimePh: 'Start time',
      endTimePh: 'End time',
      enabled: 'Enabled',
      loopStart: 'Shift loop start time',
      loopEnd: 'Shift loop end time',
      cancel: 'Cancel',
      confirm: 'Confirm',
      addTitle: 'Add Plan',
      editTitle: 'Edit Plan',
      viewTitle: 'View Plan',
      close: 'Close',
      shiftName1: 'Shift name 1',
      shiftName2: 'Shift name 2',
      shiftName3: 'Shift name 3',
      shiftName4: 'Shift name 4',
      shiftName5: 'Shift name 5',
      yes: 'Yes',
      no: 'No',
      day: {
        prev: 'Yesterday',
        today: 'Today',
        next: 'Tomorrow'
      },
      valid: {
        nameRequired: 'Please enter name',
        startTimeRequired: 'Please enter start time',
        endTimeRequired: 'Please enter end time'
      },
      warn: {
        selectToDelete: 'Please select rows to delete',
        timeRequired: '{name} start/end time cannot be empty!'
      },
      confirmDelete: 'Are you sure to delete?',
      tip: 'Tip',
      addSuccess: 'Added successfully',
      addFail: 'Add failed',
      addError: 'Network error! Add failed',
      updateSuccess: 'Updated successfully',
      updateFail: 'Update failed',
      updateError: 'Network error! Update failed',
      fetchError: 'Network error! Failed to get list!',
      deleteError: 'Network error! Delete failed',
      deleteSuccess: 'Deleted {names}'
    }
    ,
    balance: {
      breadcrumb: 'Device Management',
      add: 'Add',
      delete: 'Delete',
      paramCheck: 'Parameter Check',
      search: 'Search',
      codePh: 'Code',
      namePh: 'Name',
      loading: 'Loading...',
      index: 'Index',
      region: 'Region',
      mineName: 'Mine name',
      scaleName: 'Scale name',
      instrumentCode: 'Instrument code',
      commType: 'Communication type',
      comPort: 'Serial/Port',
      rateIp: 'Baud rate/IP',
      enabled: 'Enabled',
      showMonitor: 'Show monitor',
      homePageDisplay: 'Home page display',
      deviceType: 'Device type',
      agreementType: 'Agreement type',
      frequencyPlan: 'Shift plan',
      modifyTime: 'Operate time',
      operation: 'Operation',
      edit: 'Edit',
      warn: {
        regionRequired: 'Please select region',
        selectToDelete: 'Please select rows to delete',
        selectParamRow: 'Please select a row to set parameters',
        onlyOneRow: 'Only one row allowed',
        onlyEnabled: 'Only enabled devices can set parameters'
      },
      confirmDelete: 'Are you sure to delete?',
      tip: 'Tip',
      addError: 'Network error! Add failed',
      updateError: 'Network error! Update failed',
      deleteError: 'Network error! Delete failed',
      fetchError: 'Network error! Failed to get list!'
    }
    ,
    frequencyData: {
      breadcrumb: 'Shift Production Details',
      print: 'Print',
      export: 'Export',
      totalWeight: 'Total production (t):',
      rangeSeparator: 'to',
      startDate: 'Start date',
      endDate: 'End date',
      scale: 'Scale',
      shift: 'Shift',
      all: 'All',
      search: 'Search',
      index: 'Index',
      date: 'Date',
      scaleId: 'Scale ID',
      scaleName: 'Scale name',
      shiftCol: 'Shift',
      freqWeight: 'Shift production (t)',
      shortcuts: {
        lastWeek: 'Last week',
        lastMonth: 'Last month',
        lastThreeMonths: 'Last three months'
      },
      dateRequired: 'Date cannot be empty!',
      yes: 'Yes',
      fetchError: 'Network error! Failed to get list!',
      printTitle: 'Shift Production Details'
    }
    ,
    hourlyPower: {
      breadcrumb: 'Hourly Power Details',
      print: 'Print',
      export: 'Export',
      total: 'Total (kWh):',
      rangeSeparator: 'to',
      startDate: 'Start date',
      endDate: 'End date',
      type: 'Power type',
      search: 'Search',
      index: 'Index',
      date: 'Date',
      hour: 'Time (hour)',
      fifteenMin: '15-min power (kWh)',
      hourPower: 'Hourly power (kWh)',
      shortcuts: {
        lastWeek: 'Last week',
        lastMonth: 'Last month',
        lastThreeMonths: 'Last three months'
      },
      all: 'All',
      type1: 'Mine main gateway',
      type2: 'Underground power gateway',
      type3: 'Main transport equipment gateway',
      dateRequired: 'Date cannot be empty!',
      fetchError: 'Network error! Failed to get list!',
      printTitle: 'Hourly Power Details'
    }
    ,
    dailyPower: {
      breadcrumb: 'Daily Power Details',
      print: 'Print',
      export: 'Export',
      total: 'Total (kWh):',
      rangeSeparator: 'to',
      startDate: 'Start date',
      endDate: 'End date',
      type: 'Power type',
      search: 'Search',
      index: 'Index',
      date: 'Date',
      dayPower: 'Daily power (kWh)',
      shortcuts: {
        lastWeek: 'Last week',
        lastMonth: 'Last month',
        lastThreeMonths: 'Last three months'
      },
      all: 'All',
      type1: 'Mine main gateway',
      type2: 'Underground power gateway',
      type3: 'Main transport equipment gateway',
      dateRequired: 'Date cannot be empty!',
      fetchError: 'Network error! Failed to get list!',
      printTitle: 'Daily Power Details'
    }
    ,
    motorMonitoringDevice: {
      breadcrumb: 'Motor Monitoring',
      add: 'Add',
      delete: 'Delete',
      search: 'Search',
      codePh: 'Code',
      namePh: 'Name',
      loading: 'Loading...',
      index: 'Index',
      name: 'Name',
      deviceCode: 'Device code',
      port: 'Port',
      baudRate: 'Baud rate',
      enabled: 'Enabled',
      agreementType: 'Agreement type',
      modifyTime: 'Operate time',
      operation: 'Operation',
      edit: 'Edit',
      use: 'Use',
      cancel: 'Cancel',
      confirm: 'Confirm',
      valid: {
        codeRequired: 'Please enter code',
        codeLength: 'Length 1 to 15 characters',
        nameRequired: 'Please enter name',
        mineNameRequired: 'Please enter mine name',
        planRequired: 'Please select plan',
        zeroRequired: 'Please enter zero',
        kvRequired: 'Please enter coefficient',
        speedCoeffRequired: 'Please enter speed coefficient'
      },
      warn: {
        selectToDelete: 'Please select rows to delete',
        selectParamRow: 'Please select a row to set parameters',
        onlyOneRow: 'Only one row allowed',
        onlyEnabled: 'Only enabled devices can set parameters'
      },
      confirmDelete: 'Are you sure to delete?',
      tip: 'Tip',
      addError: 'Network error! Add failed',
      updateError: 'Network error! Update failed',
      deleteError: 'Network error! Delete failed',
      fetchError: 'Network error! Failed to get list!'
    }
    ,
    monthlyPower: {
      breadcrumb: 'Monthly Power Details',
      print: 'Print',
      export: 'Export',
      total: 'Total (kWh):',
      rangeSeparator: 'to',
      startMonth: 'Start month',
      endMonth: 'End month',
      type: 'Power type',
      search: 'Search',
      index: 'Index',
      date: 'Date',
      monthPower: 'Monthly power (kWh)',
      shortcuts: {
        thisMonth: 'This month',
        ytd: 'Year to date',
        lastSixMonths: 'Last six months'
      },
      all: 'All',
      type1: 'Mine main gateway',
      type2: 'Underground power gateway',
      type3: 'Main transport equipment gateway',
      fetchError: 'Network error! Failed to get list!',
      printTitle: 'Monthly Power Details'
    }
    ,
    annualPower: {
      breadcrumb: 'Annual Power Details',
      print: 'Print',
      export: 'Export',
      total: 'Total (kWh):',
      startYear: 'Start year',
      endYear: 'End year',
      type: 'Power type',
      search: 'Search',
      index: 'Index',
      year: 'Year',
      yearPower: 'Annual power (kWh)',
      all: 'All',
      type1: 'Mine main gateway',
      type2: 'Underground power gateway',
      type3: 'Main transport equipment gateway',
      fetchError: 'Network error! Failed to get list!',
      printTitle: 'Annual Power Details'
    }
    ,
    dailySales: {
      breadcrumb: 'Daily Accumulated Sales',
      print: 'Print',
      export: 'Export',
      total: 'Total sales (t):',
      rangeSeparator: 'to',
      startDate: 'Start date',
      endDate: 'End date',
      search: 'Search',
      index: 'Index',
      date: 'Date',
      daySales: 'Daily sales (t)',
      dayCarCount: 'Daily trips',
      shortcuts: {
        lastWeek: 'Last week',
        lastMonth: 'Last month',
        lastThreeMonths: 'Last three months'
      },
      dateRequired: 'Date cannot be empty!',
      fetchError: 'Network error! Failed to get list!',
      printTitle: 'Daily Accumulated Sales Details'
    }
    ,
    monthlySales: {
      breadcrumb: 'Monthly Accumulated Sales',
      print: 'Print',
      export: 'Export',
      total: 'Total sales (t):',
      rangeSeparator: 'to',
      startMonth: 'Start month',
      endMonth: 'End month',
      search: 'Search',
      index: 'Index',
      date: 'Date',
      monthSales: 'Monthly sales (t)',
      monthCarCount: 'Monthly trips',
      shortcuts: {
        thisMonth: 'This month',
        ytd: 'Year to date',
        lastSixMonths: 'Last six months'
      },
      fetchError: 'Network error! Failed to get list!',
      printTitle: 'Monthly Accumulated Sales Details'
    }
    ,
    annualSales: {
      breadcrumb: 'Annual Accumulated Sales',
      print: 'Print',
      export: 'Export',
      total: 'Total sales (t):',
      startYear: 'Start year',
      endYear: 'End year',
      search: 'Search',
      index: 'Index',
      year: 'Year',
      yearSales: 'Annual sales (t)',
      yearCarCount: 'Annual trips',
      fetchError: 'Network error! Failed to get list!',
      printTitle: 'Annual Accumulated Sales Details'
    }
    ,
    salesDetails: {
      breadcrumb: 'Pound Ticket Details',
      rangeSeparator: 'to',
      startDate: 'Start date',
      endDate: 'End date',
      search: 'Search',
      loading: 'Loading...',
      index: 'Index',
      operateTime: 'Operate time',
      tare: 'Tare (t)',
      tonnagePound: 'Pound tonnage',
      buyerName: 'Buyer',
      carNum: 'Plate',
      driver: 'Driver',
      carrier: 'Carrier',
      weighman: 'Weighman',
      carNumColor: 'Plate color',
      carType: 'Car type',
      crDirection: 'Direction',
      all: 'All',
      dateRequired: 'Date cannot be empty!',
      fetchError: 'Network error! Failed to get list!'
    }
    ,
    userManage: {
      breadcrumb: 'User Management',
      add: 'Add',
      delete: 'Delete',
      phonePh: 'Phone number',
      accountPh: 'Account',
      search: 'Search',
      loading: 'Loading...',
      index: 'Index',
      loginId: 'Account',
      realName: 'Name',
      phone: 'Phone',
      userType: 'User type',
      dept: 'Department',
      operator: 'Operator',
      operateTime: 'Operate time',
      actions: { edit: 'Edit' },
      dialog: {
        editTitleUpdate: 'Edit User',
        editTitleAdd: 'Add User',
        viewTitle: 'View User',
        cancel: 'Cancel',
        confirm: 'Confirm',
        close: 'Close'
      },
      fields: {
        account: 'Account',
        name: 'Name',
        password: 'Password',
        confirmPassword: 'Confirm password',
        phone: 'Phone',
        userRole: 'User role',
        dept: 'Department',
        remark: 'Remark'
      },
      rules: {
        usernameRequired: 'Please enter account',
        lengthRange: 'Length 3 to 15 characters',
        nameRequired: 'Please enter name',
        pwdSet: 'Please set password',
        pwdMin: 'Password length at least 5',
        confirmRequired: 'Please enter confirm password',
        mismatch: 'Passwords do not match',
        roleTypeRequired: 'Please select role type',
        phoneRequired: 'Please enter phone'
      },
      notify: {
        addSuccess: 'Added successfully',
        addFail: 'Add failed',
        updateSuccess: 'Updated successfully',
        updateFail: 'Update failed',
        networkAddError: 'Network error! Add failed',
        networkUpdateError: 'Network error! Update failed',
        networkListError: 'Network error! Failed to get list!',
        deleteSelectedWarning: 'Please select rows to delete!',
        deleteConfirmTitle: 'Tip',
        deleteConfirm: 'Are you sure to delete?',
        deleteSuccess: 'Deleted {names}',
        deleteFail: 'Delete failed',
        networkDeleteError: 'Network error! Delete failed'
      }
    }
    ,
    dept: {
      breadcrumb: 'Department Management',
      add: 'Add',
      delete: 'Delete',
      codePh: 'Code',
      namePh: 'Name',
      search: 'Search',
      loading: 'Loading...',
      index: 'Index',
      code: 'Code',
      name: 'Name',
      phone: 'Phone',
      address: 'Address',
      sort: 'Sort',
      enabled: 'Enabled',
      operateTime: 'Operate time',
      actions: { edit: 'Edit' },
      dialog: {
        editTitleUpdate: 'Edit Department',
        editTitleAdd: 'Add Department',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      fields: {
        code: 'Code',
        name: 'Name',
        address: 'Address',
        phone: 'Phone',
        leader: 'Leader',
        parent: 'Belongs to',
        sort: 'Sort',
        enabled: 'In use',
        remark: 'Remark'
      },
      rules: {
        codeRequired: 'Please enter code',
        lengthRange: 'Length 3 to 15 characters',
        nameRequired: 'Please enter name',
        ipRequired: 'Please enter IP'
      },
      warn: {
        levelNotAllowed: 'This level is not selectable',
        parentChangeForbidden: 'Selected department belongs to previous one, modification is forbidden!'
      },
      notify: {
        addSuccess: 'Added successfully',
        addFail: 'Add failed',
        updateSuccess: 'Updated successfully',
        updateFail: 'Update failed',
        networkAddError: 'Network error! Add failed',
        networkUpdateError: 'Network error! Update failed',
        networkListError: 'Network error! Failed to get list!',
        deleteSelectedWarning: 'Please select rows to delete!',
        deleteConfirmTitle: 'Tip',
        deleteConfirm: 'Are you sure to delete?',
        deleteSuccess: 'Deleted {names}',
        deleteFail: 'Delete failed',
        networkDeleteError: 'Network error! Delete failed'
      }
    }
    ,
    menu: {
      breadcrumb: 'Menu Management',
      add: 'Add',
      delete: 'Delete',
      namePh: 'Name',
      codePh: 'Code',
      search: 'Search',
      loading: 'Loading...',
      index: 'Index',
      title: 'Name',
      code: 'Code',
      enabled: 'Enabled',
      sort: 'Sort',
      actions: { edit: 'Edit' },
      dialog: {
        editTitleUpdate: 'Edit Menu',
        editTitleAdd: 'Add Menu',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      fields: {
        parent: 'Belongs to',
        title: 'Name',
        code: 'Code',
        icon: 'Icon',
        sort: 'Sort',
        enabled: 'In use',
        remark: 'Description'
      },
      rules: {
        codeRequired: 'Please enter code',
        lengthRange: 'Length 3 to 25 characters',
        titleRequired: 'Please enter name',
        sortRequired: 'Please enter sort'
      },
      notify: {
        addSuccess: 'Added successfully',
        addFail: 'Add failed',
        updateSuccess: 'Updated successfully',
        updateFail: 'Update failed',
        networkAddError: 'Network error! Add failed',
        networkUpdateError: 'Network error! Update failed',
        networkListError: 'Network error! Failed to get list!',
        deleteSelectedWarning: 'Please select rows to delete!',
        deleteConfirmTitle: 'Tip',
        deleteConfirm: 'Are you sure to delete?',
        deleteSuccess: 'Deleted {names}',
        deleteFail: 'Delete failed',
        networkDeleteError: 'Network error! Delete failed'
      },
      root: 'Root'
    }
    ,
    role: {
      breadcrumb: 'Role Management',
      add: 'Add',
      delete: 'Delete',
      codePh: 'Code',
      namePh: 'Name',
      search: 'Search',
      loading: 'Loading...',
      index: 'Index',
      name: 'Name',
      description: 'Description',
      enabled: 'Enabled',
      operateTime: 'Operate time',
      actions: { edit: 'Edit' },
      dialog: {
        editTitleUpdate: 'Edit Role',
        editTitleAdd: 'Add Role',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      fields: {
        name: 'Name',
        enabled: 'In use',
        description: 'Remark'
      },
      rules: {
        nameRequired: 'Please enter name',
        lengthRange: 'Length 3 to 15 characters'
      },
      notify: {
        addSuccess: 'Added successfully',
        addFail: 'Add failed',
        updateSuccess: 'Updated successfully',
        updateFail: 'Update failed',
        networkAddError: 'Network error! Add failed',
        networkUpdateError: 'Network error! Update failed',
        networkListError: 'Network error! Failed to get list!',
        deleteSelectedWarning: 'Please select rows to delete!',
        deleteConfirmTitle: 'Tip',
        deleteConfirm: 'Are you sure to delete?',
        deleteSuccess: 'Deleted {names}',
        deleteFail: 'Delete failed',
        networkDeleteError: 'Network error! Delete failed'
      },
      companyRoot: 'Company'
    }
  }
  ,
  menus: {
    BasicInfo: 'Home',
    ScaleIndex: 'Dashboard',
    DayData: 'Daily Production',
    MonthData: 'Monthly Production',
    YearData: 'Annual Production',
    HourData: 'Hourly Production',
    FrequencyData: 'Shift Production',
    RecordSearch: 'Record Search',
    EventRecord: 'Exception Record',
    OfflineRecord: 'Offline Record',
    DischargeCurve: 'Flow Curve',
    SpeedCurve: 'Speed Curve',
    CombinedCurve: 'Flow & Speed Curve',
    HisData: 'History Data',
    Frequency: 'Plan Management',
    Balance: 'Device Management',
    ScaleGroup: 'Feeder Group',
    BalanceEmpower: 'Device Permission',
    MonitorEqu: 'Monitoring Devices',
    ProductPlan: 'Production Plan Management',
    MotorMonitoringDevice: 'Motor Monitoring',
    DataMain: 'Data Dictionary',
    EquimentVersion: 'Protocol Versions',
    ClearData: 'Data Clearing',
    Role: 'Role Management',
    RolePermission: 'Role Permission',
    Menu: 'Module Settings',
    CoalTaxCalc: 'Conversion & tax estimate',
    AlarmControl: 'Alarm Control',
    MTStandard: 'MT1082 Standard Reports',
    MTOverYearShow: 'Annual Overproduction Display',
    MTOverMonthShow: 'Monthly Overproduction Display',
    MTOutputYearQuery: 'Annual Output Query & Display',
    MTOutputMonthQuery: 'Monthly Output Query & Display',
    MTOutputDayQuery: 'Daily Output Query & Display',
    MTAbnormalDisplay: 'System Abnormality Display'
  }
  ,
  menusTitles: {
    '设备动态信息': 'Device Dynamic Info',
    '皮带秤首页': 'Belt Scale Home',
    '动态信息': 'Dynamic Info',
    '皮带秤展示': 'Belt Scale Display',
    '皮带秤状态': 'Belt Scale Status',
    '运行状态': 'Running Status',
    'AI称重系统': 'AI Weighing System',
    'AI称重系统大屏': 'AI Weighing Dashboard',
    '秤架组管理': 'Weighing Rack Group',
    '托辊管理': 'Idler Management',
    '托辊电机管理': 'Idler Motor',
    '托辊称重传感器管理': 'Idler Load Sensor',
    '托辊震动传感器管理': 'Idler Vibration Sensor',
    'AI称重系统监控设置': 'AI Monitor Settings',
    'AI称重系统设置': 'AI System Settings',
    '系统设置': 'System Settings',
    '用户管理': 'User Management',
    '部门管理': 'Department Management',
    '菜单管理': 'Menu Management',
    '关于': 'About',
    '设备设置': 'Device Settings',
    '设备管理': 'Device Management',
    '监控设备': 'Monitoring Devices',
    '电机监测设备': 'Motor Monitoring',
    '设备权限': 'Device Permission',
    '产量计划管理': 'Production Plan Management',
    '给料机组管理': 'Feeder Group',
    '计划管理': 'Plan Management',
    '超产查询': 'Overproduction',
    '年超产查询': 'Annual Overproduction',
    '月超产查询': 'Monthly Overproduction',
    '产量查询': 'Production Query',
    '班产量查询': 'Shift Production',
    '时产量查询': 'Hourly Production',
    '日产量查询': 'Daily Production',
    '月产量查询': 'Monthly Production',
    '年产量查询': 'Annual Production',
    '数据查询': 'Data Query',
    '流量曲线': 'Flow Curve',
    '记录查询': 'Record Search',
    '监控记录': 'Monitor Records',
    '启停记录': 'Start/Stop Records',
    '离线记录': 'Offline Records',
    '历史数据': 'History Data',
    '数据清除': 'Data Clearing',
    '数据字典': 'Data Dictionary',
    '功能模块设置': 'Module Settings',
    '协议版本信息': 'Protocol Versions',
    '角色管理': 'Role Management',
    '角色权限': 'Role Permission',
    '报警消音控制': 'Alarm Control'
  }
  ,
  common: {
    modifySuccess: 'Updated successfully',
    modifyFail: 'Update failed',
    networkListError: 'Network error! Failed to get list!',
    networkModifyError: 'Network error! Update failed',
    inputPositiveInt: 'Please enter a positive integer!',
    refresh: 'Refresh',
    reset: 'Reset',
    save: 'Save'
  }
}
